export class ApiException extends Error {
    constructor(message) {
        super(message);
        this.message = message;
    }
}
